import type { ConfigFileOverride, ConfigurationFile } from '@/api/configuration';

export interface ResolvedConfigFields {
  sourceRoot: { value: string; source: 'override' | 'default' };
  targetLocation: { value: string; source: 'override' | 'default' };
  targetFilename: { value: string; source: 'override' | 'default' };
}

/**
 * Resolves the effective field values for a configuration file in a given environment.
 * Override values take precedence when non-empty; otherwise falls back to defaults.
 */
export function resolveConfigFields(
  configFile: ConfigurationFile,
  override: ConfigFileOverride | undefined
): ResolvedConfigFields {
  return {
    sourceRoot: {
      value: override?.sourceRoot || configFile.defaultSourceRoot || '',
      source: override?.sourceRoot ? 'override' : 'default',
    },
    targetLocation: {
      value: override?.targetLocation || configFile.targetLocation || '',
      source: override?.targetLocation ? 'override' : 'default',
    },
    targetFilename: {
      value: override?.targetFilename || configFile.targetFilename || '',
      source: override?.targetFilename ? 'override' : 'default',
    },
  };
}
